import React from "react";

import github from "../svg/github.1413f4f4.svg";
import link from "../svg/link.dada9769.svg";
import Pagetrans from "./pagetrans";

const Portfoliopage = () => {
  return (
    <main className="portfolio py-lg-5 titled-section trans ">
      <Pagetrans className="container py-lg-3 py-xl-5">
        <h1 className="section-title text-uppercase">
          Portfolio{" "}
          <span className="bg decorate text-uppercase d-none d-md-block">
            work
          </span>
        </h1>
        <div className="card-columns">
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">Zendi</h5>
              <p className="card-text">
                Zendi is a door-door delivery and errand service provider. I
                designed the API for the application
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/zendibackend"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a
                  href="https://zendi.herokuapp.com"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">Dashboard</h5>
              <p className="card-text">
                A sleek dashboard design made with ReactJs.
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/dashboard"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a
                  href="nattarbase-dashboard.netlify.app"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">CBT App</h5>
              <p className="card-text">
                Front-end for a computer based application built with React and
                Typescript
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/computer-based-assessment"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a href="#not-live" target="_blank" rel="noreferrer noopener">
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">Airtime Saga</h5>
              <p className="card-text">
                An app that disburses airtime to west african phone numbers
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/airtime-disburser"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a href="#not-live" target="_blank" rel="noreferrer noopener">
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">Image Resizer</h5>
              <p className="card-text">
                An api that does basic manipulation on images built with Node
                and Express
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/image-resizing-service"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a href="#not-live" target="_blank" rel="noreferrer noopener">
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">User Management Service</h5>
              <p className="card-text">
                A dockerized user management micro api service built using Node
                and Express
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/user-management-microapi"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a href="#not-live" target="_blank" rel="noreferrer noopener">
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
          <div className="card project-card">
            <div className="card-body">
              <h5 className="card-title">Authentication API</h5>
              <p className="card-text">
                A dockerized authentication manager API built with Node and
                Express
              </p>
              <div className="project-links">
                <a
                  href="https://github.com/mhizterkeyz/auth-microapi"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img src={github} alt="git icon" />
                </a>
                <a href="#not-live" target="_blank" rel="noreferrer noopener">
                  <img src={link} alt="external link icon" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Pagetrans>
    </main>
  );
};

export default Portfoliopage;
